// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_37496","author-name":"VZsNb"};